import { server_connection } from 'config';
import { portal_url } from 'config';

import {auth} from 'firebase-db';
import {setUserData} from 'auth/store/actions/user.actions';
import * as Actions from 'store/actions';
import history from 'history.js';
import { USER_LOGGED_OUT } from './user.actions';

export const LOGIN_ERROR   = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function submitLogin({username, password}) {
    return (dispatch, getState) => {
        fetch(server_connection+'/auth/login',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ username, password })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.SUCCESS) {
                    dispatch(setUserData(responseData.data));

                    if (responseData.data.Verified === 0) {
                        dispatch({
                            type: LOGIN_SUCCESS,
                        });
                        return history.push('/password_verify');
                    }

                    return dispatch({
                        type: LOGIN_SUCCESS,
                    });

                } else {
                    return dispatch({
                        type: LOGIN_ERROR,
                        payload: responseData.error
                    });
                }
            });
    }
}

export function submitLoginJWT(token, token_date) {
    return (dispatch) => {
        fetch(server_connection + '/auth/jwt_login',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ token: token, token_date: token_date})
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.SUCCESS) {
                    dispatch(setUserData(responseData.data));

                    return dispatch({
                        type: LOGIN_SUCCESS,
                    });
                } else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token_date');

                    history.push('/login');
                    window.location.reload();
                }
            });
    }
}

export function loginWithFireBase({ username, password }) {
    return (dispatch) =>
        auth.signInWithEmailAndPassword(username, password)
            .then(() => {
                return dispatch({
                    type: LOGIN_SUCCESS
                });
            })
            .catch(error => {
                const usernameErrorCodes = [
                    'auth/email-already-in-use',
                    'auth/invalid-email',
                    'auth/operation-not-allowed',
                    'auth/user-not-found',
                    'auth/user-disabled'
                ];
                const passwordErrorCodes = [
                    'auth/weak-password',
                    'auth/wrong-password'
                ];

                const response = {
                    username: usernameErrorCodes.includes(error.code) ? error.message : null,
                    password: passwordErrorCodes.includes(error.code) ? error.message : null
                };

                if (error.code === 'auth/invalid-api-key') {
                    dispatch(Actions.showMessage({ message: error.message }));
                }

                return dispatch({
                    type: LOGIN_ERROR,
                    payload: response
                });
            });
}

export function checkPortalTokenValid(portalToken) {
    return (dispatch) => {
        fetch(server_connection + '/auth/check_portal_token_valid',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ portalToken })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.valid) {
                } else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token_date');
                    localStorage.removeItem('portal_token');

                    window.location.replace(
                        `${portal_url}/dashboard`
                    );
                    dispatch({
                        type: USER_LOGGED_OUT
                    })
                }
            });
    }
}


// WEBPACK FOOTER //
// src/auth/store/actions/login.actions.js